import settings from '../xwiki/settings';
import ApiUtils from '../xwiki/ApiUtils';
import { mapWikis, mapSpaces, makeTreeSpaces } from '../xwiki/helper';

/** Специальные действия для получения информации о wiki страницах
 * Например, список нодов, вложенных страниц
 */
export const XWikiActions = {
  EMPTY: () => ({
    type: "XWikiActions.EMPTY"
  }),
  LOAD_STARTED: () => ({
    type: "XWikiActions.LOAD_STARTED"
  }),
  LOAD_ERROR: (error) => ({
    type: "XWikiActions.LOAD_ERROR",
    error,
  }),

  WIKIS: (response) => ({
    type: "XWikiActions.WIKIS",
    wikis: mapWikis(response),
  }),

  SPACES: (response) => ({
    type: "XWikiActions.NODES",
    nodes: makeTreeSpaces(mapSpaces(response)),
  }),

  NODES: (nodes) => ({
    type: "XWikiActions.NODES",
    nodes,
  }),
  NODEPAGES: (nodeId, pages) => ({
    type: "XWikiActions.NODEPAGES",
    nodeId, pages,
  }),
  SELECTED: (page) => ({
    type: "XWikiActions.SELECTED",
    page,
  }),

  /** Загрузить список доступных wiki узлов */
  loadWikis: () => dispatch => {
    //Сделаем событие, что начали загружать данные 
    dispatch(XWikiActions.LOAD_STARTED());
    const options = {...settings.options};
    
    return ApiUtils.getWikis()
      .then ((response) =>{
        //console.log("XWikiActions.js Done!", response);
        dispatch(XWikiActions.WIKIS(response));
        return Promise.resolve(response);
      })
      .catch(e => { 
        dispatch(XWikiActions.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
        return Promise.reject(e);
      });
  },

  /** Загрузить список доступных space узлов */
  loadSpaces: (wiki = "xwiki") => dispatch => {
    //Сделаем событие, что начали загружать данные 
    dispatch(XWikiActions.LOAD_STARTED());
    const options = {...settings.options};
    
    return ApiUtils.getSpaces(wiki)
      .then ((response) =>{
        console.log("XWikiActions.js Done!", response);
        //const { count, items, years} = response;
        dispatch(XWikiActions.SPACES(response));
        return Promise.resolve(response);
      })
      .catch(e => { 
        dispatch(XWikiActions.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
        return Promise.reject(e);
      });
  },

  // /** Загрузить список доступных wiki статей для узла  */
  // loadNodePages: (nodeId, max=100) => dispatch => {
  //   //Сделаем событие, что начали загружать данные 
  //   dispatch(WikiActions.LOAD_STARTED());
  //   const options = {...settings.options};
  //   const formData = {
  //     'cmd': JSON.stringify({'/wiki.wikipage/get-node-pages':{}}),
  //     'formDate': new Date().getMilliseconds(),
  //     'nodeId': nodeId,
  //     'max': max
  //   }
  //   return ApiUtils.postToLifeRay721(formData, options)
  //     .then ((response) =>{
  //       console.log("Done!", response);
  //       //const { count, items, years} = response;
  //       dispatch(WikiActions.NODEPAGES(nodeId, response));
  //       return Promise.resolve(response);
  //     })
  //     .catch(e => { 
  //       dispatch(WikiActions.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
  //       return Promise.reject(e);
  //     });
  // },

};
